import { lazyLoad } from 'utils/loadable';

export const NewsFormPage = lazyLoad(
  () => import('./index'),
  module => module.NewsFormPage,
);
